import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IAddWorkerToInterventionRequestAction {
  data: {
    id: string;
    intervention_id: number;
  };
  functions: {
    error: (err: any) => void;
  };
}

function addWorkerRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IAddWorkerToInterventionRequestAction>,
) {
  draft.addWorker.config.isLoading = true;
}

export default addWorkerRequest;
